import React from 'react';
import { NavLink } from 'react-router-dom';
import { ActivityIcon, ChevronsLeftIcon } from 'lucide-react';
import { navGroups } from '../../data/navigation';
import { cn } from '../../lib/cn';
interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}
const badgeTones: Record<string, string> = {
  danger: 'bg-red-500 text-white',
  warning: 'bg-amber-500 text-white',
  brand: 'bg-brand-600 text-white'
};
export function Sidebar({
  collapsed,
  onToggle
}: SidebarProps) {
  return <aside className={cn('hidden md:flex flex-col shrink-0 border-r border-slate-800 bg-slate-900 text-slate-300 transition-all duration-300', collapsed ? 'w-[68px]' : 'w-64')} data-id="element-351" data-mp="30rkghc27k9i0">
      <div className="flex h-14 items-center gap-2.5 px-4 border-b border-slate-800" data-id="element-352" data-mp="3ap8dk8nadt3c">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-600 text-white" data-id="element-353" data-mp="1bdywjn6l9220">
          <ActivityIcon className="h-5 w-5" data-id="element-354" data-mp="1gdbh219zlx1f" />
        </div>
        {!collapsed && <div className="min-w-0" data-id="element-355" data-mp="1w0cdxdnr91tx">
            <p className="font-display text-sm font-bold text-white leading-tight truncate" data-id="element-356" data-mp="1w1njnj0rgjno">Creative Energy - EHR</p>
            <p className="text-[10px] text-brand-200 leading-tight truncate" data-id="element-357" data-mp="1r79iezzf3ib3">Integrated Healthcare Enterprise</p>
          </div>}
      </div>

      <nav className="flex-1 overflow-y-auto py-3 px-2.5 space-y-4" data-id="element-358" data-mp="1i9h2pupsa8n6">
        {navGroups.map(group => <div key={group.title} data-id="element-359" data-mp="2exvqgr9f92l3">
            {!collapsed && <p className="px-2 mb-1.5 text-[10px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-360" data-mp="2a03muzzezs12">
                {group.title}
              </p>}
            <div className="space-y-0.5" data-id="element-361" data-mp="260d15aoqw23e">
              {group.items.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/' || item.to === '/finance'} title={collapsed ? item.label : undefined} className={({
            isActive
          }) => cn('group flex items-center gap-3 rounded-lg px-2.5 py-2 text-sm font-medium transition-colors relative', isActive ? 'bg-brand-600/15 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white', collapsed && 'justify-center')} data-id="element-362" data-mp="20yw1tjlwsnox">
                  {({
              isActive
            }) => <>
                      {isActive && <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-1 rounded-r-full bg-brand-500" data-id="element-363" data-mp="d2ze2o7vdx4k" />}
                      <item.icon className="h-[18px] w-[18px] shrink-0" data-id="element-364" data-mp="3bboksuviq5q" />
                      {!collapsed && <span className="flex-1 truncate" data-id="element-365" data-mp="3lh7vr18ut3hy">{item.label}</span>}
                      {!collapsed && item.badge && <span className={cn('ml-auto rounded-full px-1.5 py-px text-[10px] font-bold', badgeTones[item.badgeTone || 'brand'])} data-id="element-366" data-mp="3qgkjrpbgogm4">
                          {item.badge}
                        </span>}
                      {collapsed && item.badge && <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-red-500" data-id="element-367" data-mp="3bs10ichochd8" />}
                    </>}
                </NavLink>)}
            </div>
          </div>)}
      </nav>

      <button onClick={onToggle} className="flex h-11 items-center gap-2 border-t border-slate-800 px-4 text-xs font-medium text-slate-400 hover:text-white hover:bg-slate-800 transition-colors" data-id="element-368" data-mp="3eakxcq1ajfo">
        <ChevronsLeftIcon className={cn('h-4 w-4 transition-transform', collapsed && 'rotate-180')} data-id="element-369" data-mp="cficlby1om0s" />
        {!collapsed && <span data-id="element-370" data-mp="7gytrkeqzqcn">Collapse</span>}
      </button>
    </aside>;
}